import { useDispatch } from "react-redux"
import { addItem } from "../utils/cartSlice"
import { CDN_URL } from "../utils/constants"

const ItemList = ({ item }) => {
  const items = item?.card?.card?.itemCards
  console.log(items)
  const dispatch=useDispatch()
 
  return (
    <div>
      {items.map((x) => {
        return (
          <div
            className="flex  bg-slate-200 p-2 m-1 shadow-lg justify-between hover:bg-amber-200 hover:translate-y-[-10px] transform transition-transform duration-300"
            key={x?.card?.info?.id}
          >
            <div className="w-9/12">
              {" "}
              <span>{x?.card?.info?.name}</span>
              <h2>৳{x?.card?.info?.price / 100}</h2>
              <p className="text-xs text-slate-500 mt-5">
                {x?.card?.info?.description}
              </p>
            </div>

            <div className="w-3/12">
              <div className="absolute">
                <button className="bg-black text-white rounded p-2 hover:translate-y-[10px] transform transition-transform duration-300" onClick={()=> dispatch(addItem(x))}> Add + </button>
              </div>
              <img
                src={CDN_URL + x?.card?.info?.imageId}
                className=" rounded m-1"
              ></img>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ItemList
